import EncumbranceDetails from '../pages/EncumbranceDetails';
import { EncumbranceDetailsPageProvider } from '../pages/EncumbranceDetails/context/EncumbranceDetailsPageContext';

const EncumbranceDetailsPageContainer = () => (
  <EncumbranceDetailsPageProvider>
    <EncumbranceDetails />
  </EncumbranceDetailsPageProvider>
);

export default EncumbranceDetailsPageContainer;
